export const NOT_ENROLLED_STATUSES = [
  "Not Enrolled",
  "Screened",
  "Screen Failed",
];
